import qs from 'qs'

/**
 * 다중값 파라미터를 `key=a&key=b` 로 직렬화한다.
 *
 * 공용 `Utils.qsStringify` 는 `arrayFormat: 'comma'` + `encode: false` 라 이 API 에 맞지 않는다 —
 * 화주명/센터명/브랜드명이 한글이라 인코딩이 필요하고, 값 자체에 콤마가 들어오면 comma 형식은 값이 쪼개진다.
 * `repeat` 는 Spring `@RequestParam List<String>` 이 그대로 받는 형식이다.
 *
 * 빈 문자열은 제외한다 — EQUAL 필터에 빈 값이 걸리면 무결과가 된다.
 * (센터명 '전체' 는 빈 값으로 오는데, 파라미터가 아예 빠져야 BE 가 조건을 걸지 않는다.)
 */
export const toRepeatQuery = <T extends object>(params: T): string =>
  qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true, filter: (_, value) => (value === '' ? undefined : value) })
